import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { Select } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import { checkIsKeyInObject } from 'utils';
import ChevrondownIcon from 'icons/Chevrondown.icon';

import './BulkUploadSelect.styles.scss';

type BulkUploadSelectProps = {
  className?: string;
  column: string;
  index?: number;
  allColumns: string[];
  allowReplaceSelected?: boolean;
  options: Record<string, any>;
  onUpdateColumn?: (key: string, newValue: string) => void;
};

const BulkUploadSelect: React.FC<BulkUploadSelectProps> = (props) => {
  const {
    className,
    column,
    index,
    options,
    allColumns,
    allowReplaceSelected = true,
    onUpdateColumn,
  } = props;

  const classes = classNames('bulk-upload-select', className);

  const { t } = useTranslation();

  const isUnSelectDisabled = !checkIsKeyInObject(column, options);

  const headerOptions = useMemo(
    () => [
      ...Object.entries(options).map(([value, label]) => ({
        value,
        label: t(label),
        disabled:
          !allowReplaceSelected &&
          allColumns?.includes(value) &&
          column !== value,
      })),
      {
        value: `${column}-${index}`,
        label: t('none'),
        disabled: isUnSelectDisabled,
      },
    ],
    [
      options,
      column,
      index,
      t,
      isUnSelectDisabled,
      allColumns,
      allowReplaceSelected,
    ],
  );

  const onChange = useCallback(
    ({ value }) => onUpdateColumn(column, value),
    [column, onUpdateColumn],
  );

  return (
    <Select
      renderAsPortal
      value={column}
      className={classes}
      portalClassName="bulk-upload-select__portal"
      placeholder={t('choose')}
      icon={<ChevrondownIcon />}
      options={headerOptions}
      onChange={onChange}
    />
  );
};

export default BulkUploadSelect;
